import { useRef, useState } from "react";
import PricingManager from "./PricingManager";
import { LeftSide } from "./leftSide";
import CouponTable from "./CouponTable";
import CombineBundleTable from "./CombineBundleTable";

function AdminSettings() {
  const [tab, setTab] = useState("coupons");
  const couponTableRef = useRef(null);
  const bundleTableRef = useRef(null);

  const handleCreateClick = () => {
    if (tab === "coupons") {
      couponTableRef.current?.openCreateForm();
    } else {
      bundleTableRef.current?.openCreateForm();
    }
  };

  const handleTabKeyDown = (e, tabName) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setTab(tabName);
    }
  };

  return (
    <div className="p-4 h-full bg-gray-100 overflow-auto pb-28 md:pb-0">
      <div className="flex flex-col xl:flex-row lg:flex-row gap-4">
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <LeftSide />
        </div>
        <div className="w-full lg:w-2/4 xl:w-2/4">
          <div className="flex h-auto">
            <PricingManager />
          </div>

          <div className="w-full bg-white shadow-lg rounded-lg p-4 mt-4">
            <div className="mb-4">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-gray-200">
                <h2 className="text-xl uppercase">
                  Coupons &amp; Combine Bundles
                </h2>
                <button
                  className="px-4 py-2 rounded bg-blue-600 hover:bg-blue-800 text-white uppercase text-sm"
                  onClick={handleCreateClick}
                >
                  {tab === "coupons" ? "+ New Coupon" : "+ New Combine Bundle"}
                </button>
              </div>
              <ul className="flex gap-4 pt-4" role="tablist">
                <li
                  role="tab"
                  tabIndex={0}
                  aria-selected={tab === "coupons"}
                  className={`pb-2 cursor-pointer uppercase text-sm ${
                    tab === "coupons"
                      ? "border-b-2 border-blue-600 font-semibold"
                      : "text-gray-500"
                  }`}
                  onClick={() => setTab("coupons")}
                  onKeyDown={(e) => handleTabKeyDown(e, "coupons")}
                >
                  Coupons
                </li>
                <li
                  role="tab"
                  tabIndex={0}
                  aria-selected={tab === "combineBundles"}
                  className={`pb-2 cursor-pointer uppercase text-sm ${
                    tab === "combineBundles"
                      ? "border-b-2 border-blue-600 font-semibold"
                      : "text-gray-500"
                  }`}
                  onClick={() => setTab("combineBundles")}
                  onKeyDown={(e) => handleTabKeyDown(e, "combineBundles")}
                >
                  Combine Bundles
                </li>
              </ul>
            </div>

            {tab === "coupons" ? (
              <CouponTable ref={couponTableRef} />
            ) : (
              <CombineBundleTable ref={bundleTableRef} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSettings;
